import React, { useState } from "react";
import axios from "axios";
import { MapContainer, Marker, Polyline, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import spotGreenIcon from "../../assets/icons/map-icon.svg";
import DrawMapInteraction from "../spotForm/map/DrawMapInteraction";
import InvalidateMapSizeOnMount from "../spotForm/map/InvalidateMapSizeOnMount";
import { useNotification } from "../../notifications/NotificationContext";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";
const spotIcon = L.icon({ iconUrl: spotGreenIcon, iconSize: [60, 40], iconAnchor: [30, 40] });

export default function SpotDrawRouteModal({ spotId, latitude, longitude, onClose, onSaved }) {
    const { showNotification } = useNotification();
    const [drawMode, setDrawMode] = useState("move");
    const [drawPoints, setDrawPoints] = useState([]);
    const [, setDrawSegments] = useState([]);
    const [routeDescription, setRouteDescription] = useState("");

    const closeSafely = () => {
        if (drawPoints.length > 0 || routeDescription.trim()) {
            const confirmed = window.confirm("Закрыть рисование маршрута? Несохраненные изменения будут потеряны.");
            if (!confirmed) return;
        }
        onClose?.();
    };

    const saveRoute = async () => {
        if (!spotId || drawPoints.length < 2) return;
        const coordinates = drawPoints.map(([lat, lng]) => [lng, lat]);
        try {
            await axios.post(`${API_BASE_URL}/api/spots/${spotId}/routes`, {
                geometry: { type: "LineString", coordinates },
                description: routeDescription,
            }, { withCredentials: true });
            const successText = "После модерации ваш маршрут будет отображен на сайте.";
            showNotification({ type: "success", text: successText });
            onSaved?.();
            onClose?.();
        } catch (e) {
            showNotification({ type: "error", text: e?.response?.data?.error || "Не удалось сохранить маршрут." });
        }
    };

    const lat = Number(latitude) || 53.885;
    const lng = Number(longitude) || 27.554;

    return (
        <div className="entity-popup__draw-backdrop" onClick={closeSafely}>
            <div className="auth-modal" style={{ width: "90%", maxWidth: 900 }} onClick={(e) => e.stopPropagation()}>
                <button type="button" className="entity-popup__close" onClick={closeSafely} aria-label="Закрыть рисование">
                    ×
                </button>
                <h3>Нарисовать маршрут</h3>
                <div className="draw-toolbar-row">
                    <div className="draw-mode-toggle">
                        <span>Перемещение</span>
                        <button
                            type="button"
                            className={`draw-mode-toggle__switch ${drawMode === "draw" ? "is-draw" : ""}`}
                            onClick={() => setDrawMode((prev) => (prev === "draw" ? "move" : "draw"))}
                            aria-label={drawMode === "draw" ? "Выключить рисование" : "Включить рисование"}
                        >
                            <span className="draw-mode-toggle__thumb" />
                        </button>
                        <span>Рисование</span>
                    </div>
                    <div className="draw-toolbar-row__actions">
                        <button
                            type="button"
                            className="btn-outline"
                            title="Отменить"
                            style={{ padding: "8px" }}
                            aria-label="Отменить"
                            onClick={() => {
                                setDrawSegments((prev) => {
                                    if (!prev.length) return prev;
                                    const removed = prev[prev.length - 1].length || 0;
                                    if (removed > 0) {
                                        setDrawPoints((points) => points.slice(0, -removed));
                                    }
                                    return prev.slice(0, -1);
                                });
                            }}
                        >
                            Отменить
                        </button>
                        <button
                            type="button"
                            className="btn-outline"
                            style={{ padding: "8px" }}
                            title="Очистить"
                            aria-label="Очистить"
                            onClick={() => setDrawPoints([])}
                        >
                            Очистить
                        </button>
                    </div>
                </div>
                <MapContainer center={[lat, lng]} zoom={13} style={{ height: 360 }}>
                    <TileLayer attribution="&copy; OpenStreetMap contributors" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <InvalidateMapSizeOnMount />
                    {Number.isFinite(lat) && Number.isFinite(lng) && (
                        <Marker icon={spotIcon} position={[lat, lng]} />
                    )}
                    <Polyline positions={drawPoints} />
                    <DrawMapInteraction
                        mode={drawMode}
                        onStrokeStart={() => setDrawSegments((prev) => [...prev, []])}
                        onAdd={(point) => {
                            setDrawPoints((prev) => [...prev, point]);
                            setDrawSegments((prev) => {
                                if (!prev.length) return [[point]];
                                const copy = [...prev];
                                copy[copy.length - 1] = [...copy[copy.length - 1], point];
                                return copy;
                            });
                        }}
                    />
                </MapContainer>
                <textarea
                    className="ui-textarea"
                    rows={2}
                    value={routeDescription}
                    onChange={(e) => setRouteDescription(e.target.value)}
                    placeholder="Описание маршрута (необязательно)"
                />
                <div className="auth-form__actions" style={{ marginTop: 8 }}>
                    <button type="button" className="toolbar-btn" onClick={saveRoute} disabled={drawPoints.length < 2}>
                        Сохранить
                    </button>
                    <button type="button" className="btn-outline" onClick={closeSafely}>Отмена</button>
                </div>
            </div>
        </div>
    );
}
